module.exports = __webpack_public_path__ + "static/media/S2N14-4.55a2542d.svg";